import styled from 'styled-components';
import React from 'react';

export const ImageContainer = styled.div`
  width: ${props => props.width || '260px'};
  max-width: ${props => props.maxWidth || '260px'};
  height: auto;
  margin: ${props => props.margin || '10px 0'};
  
  img {
  width: 100%;
`

export default (props) =>
  <ImageContainer maxWidth = {props.maxWidth} width = {props.width} margin={props.margin}>
    <img src={props.backgroundImage} alt={props.alt}/>
  </ImageContainer>


// WEBPACK FOOTER //
// ./src/components/image/index.js